var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "transition-scale-fade" } }, [
    _vm.isShowing
      ? _c(
          "div",
          {
            staticClass:
              "terms-acceptance-reminder card roomy text-left with-border",
            staticStyle: {
              position: "fixed",
              bottom: "100px",
              right: "0",
              "max-width": "40rem",
              "z-index": "var(--depth-3)",
              "margin-inline": "var(--spacing-lg)",
            },
          },
          [
            _c("h2", { staticClass: "h4 margin-top-0" }, [
              _vm._v("Review and Accept Our Terms"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Greetings, mellow Font Awesome citizen! It appears that you haven't accepted our most recent policies and terms of service."
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "margin-y-xl" },
              [
                _c("owa-accept-policies-checkbox", {
                  model: {
                    value: _vm.acceptPolicies,
                    callback: function ($$v) {
                      _vm.acceptPolicies = $$v
                    },
                    expression: "acceptPolicies",
                  },
                }),
                _vm._v(" "),
                _vm.shouldShowMarketingOptIn
                  ? [
                      _c(
                        "label",
                        {
                          staticClass: "margin-x-0 margin-y-sm",
                          staticStyle: {
                            "--label-font-size": "var(--font-size-sm)",
                            "--link-color": "var(--fa-navy)",
                            "--label-font-weight": "normal",
                            display: "flex",
                            gap: "var(--spacing-3xs)",
                          },
                          attrs: { for: "opt-into-marketing" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "opt-into-marketing",
                              name: "opt-into-marketing",
                              type: "checkbox",
                            },
                            domProps: { checked: _vm.optIntoMarketing },
                            on: {
                              change: (event) =>
                                (_vm.optIntoMarketing = event.target.checked),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _vm._v(
                                "\n            Send me Font Awesome emails, or\n            "
                              ),
                              _c(
                                "site-link",
                                {
                                  staticClass: "strong",
                                  attrs: {
                                    to: {
                                      name: "account.settings",
                                      hash: "#email-prefs",
                                    },
                                  },
                                },
                                [_vm._v("let me adjust my email preferences")]
                              ),
                              _vm._v(".\n          "),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "p",
                        {
                          staticClass: "margin-top-2xl size-sm",
                          staticStyle: {
                            "--label-font-size": "var(--font-size-sm)",
                            "--link-color": "var(--fa-navy)",
                          },
                        },
                        [
                          _vm._v(
                            "\n          And, if you like, you can\n          "
                          ),
                          _c(
                            "site-link",
                            {
                              staticClass: "strong",
                              attrs: {
                                to: {
                                  name: "account.settings",
                                  hash: "#email-prefs",
                                },
                              },
                            },
                            [_vm._v("adjust your email marketing preferences")]
                          ),
                          _vm._v("\n          in your account.\n        "),
                        ],
                        1
                      ),
                    ],
                _vm._v(" "),
                _vm.errorMessage
                  ? _c("owa-message", {
                      staticClass: "margin-top-md",
                      attrs: {
                        theme: "danger",
                        type: "flash",
                        content: _vm.errorMessage,
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "display-flex flex-column align-between tablet:flex-row tablet:flex-items-center margin-top-lg",
                staticStyle: { gap: "var(--spacing-md)" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "button link flat margin-bottom-0",
                    attrs: {
                      href: "mailto:help@fontawesome.com?subject=I have questions about the terms!",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v("\n        Contact Support\n      ")]
                ),
                _vm._v(" "),
                _c("owa-action-button", {
                  attrs: {
                    label: "Go Make Something Awesome!",
                    theme: "success",
                    "is-full-width": false,
                    "icon-name": "faRocketLaunch",
                    "icon-style": "solid",
                    disabled: !_vm.acceptPolicies || _vm.isProcessing,
                    "is-processing": _vm.isProcessing,
                  },
                  on: { click: _vm.confirmAcceptance },
                }),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }